import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

// Use the TileInfo interface from ImageViewer
interface TileInfo {
    level: number;
    url: string;
    bounds: any;
    position: any;
    resultId: string;
}

// The payload that backend accepts
export interface TilePayload {
    url: string;
    resultId: string;
}

export interface TileResponse {
    id: string;
    image_id: string;
    result_id: string;
    source_tile_url: string;
    target_tile_url: string;
    created_at: string;
    updated_at: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
}

interface TileSelectionState {
    selectionModeOn: boolean;
    selectedTiles: TileInfo[];
}

const initialState: TileSelectionState = {
    selectionModeOn: false,
    selectedTiles: [],
};

const tileSelectionSlice = createSlice({
    name: 'tileSelection',
    initialState,
    reducers: {
        addTile: (state, action: PayloadAction<TileInfo>) => {
            // Check if tile with same URL already exists to avoid duplicates
            if (!state.selectedTiles.some(tile => tile.url === action.payload.url)) {
                state.selectedTiles.push(action.payload);
            }
        },
        removeTile: (state, action: PayloadAction<string>) => {
            // Remove tile by URL
            state.selectedTiles = state.selectedTiles.filter(tile => tile.url !== action.payload);
        },
        clearSelection: (state) => {
            state.selectedTiles = [];
        },
        toggleTile: (state, action: PayloadAction<TileInfo>) => {
            const index = state.selectedTiles.findIndex(tile => tile.url === action.payload.url);
            if (index === -1) {
                state.selectedTiles.push(action.payload);
            } else {
                state.selectedTiles.splice(index, 1);
            }
        },
        toggleSelectionMode: (state) => {
            state.selectionModeOn = !state.selectionModeOn
            return state;
        }
    },
});

// Export actions
export const { addTile, removeTile, clearSelection, toggleTile, toggleSelectionMode } = tileSelectionSlice.actions;

// Export selectors
export const selectSelectedTiles = (state: RootState) => state.tileSelection.selectedTiles;
export const selectSelectionMode = (state: RootState) => state.tileSelection.selectionModeOn;

export default tileSelectionSlice.reducer;
